import React, { useState, useEffect } from "react";
import Api from "../../api/index";

const WinLimitManager = () => {
  const [form, setForm] = useState({
    date: "",
    fromHour: "",
    toHour: "",
    amount: "",
  });

  const [winLimits, setWinLimits] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWinLimits = async () => {
      try {
        const response = await Api.get("/winLimits", { withCredentials: true });
        const data = await response.data;

        if (data.success) {
          setWinLimits(data.result);
        } else {
          setError("Failed to load win limits");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWinLimits();
  }, []);


  const toFormUrlEncoded = (obj) =>
    Object.keys(obj)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join("&");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const requestData = {
      date: form.date,
      startTime: form.fromHour,
      endTime: form.toHour,
      maxAmount: parseInt(form.amount, 10),
    };

    const formData = toFormUrlEncoded(requestData);

    try {
      const response = await Api.post("/winLimits", formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        withCredentials: true
      });

      const result = response.data;

      if (result.success) {
        setWinLimits((prev) => [result.result, ...prev].slice(0, 5));
        setForm({ date: "", fromHour: "", toHour: "", amount: "" });
      } else {
        setError("Failed to save win limit");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const formatTimeRange = (from, to) => `${from} - ${to}`;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Gestion des Limites de Gains</h2>

      {error && <div style={styles.error}>{error}</div>}

      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>Limites Existantes</h3>
        {isLoading ? (
          <div style={styles.loading}>Chargement...</div>
        ) : winLimits.length > 0 ? (
          <div style={{ overflowX: "auto" }}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Période</th>
                  <th style={styles.th}>Montant Max</th>
                </tr>
              </thead>
              <tbody>
                {winLimits.map((limit, index) => (
                  <tr
                    key={index}
                    style={index % 2 === 0 ? styles.trEven : styles.trOdd}
                  >
                    <td style={styles.td}>{limit.date}</td>
                    <td style={styles.td}>
                      {formatTimeRange(limit.startTime, limit.endTime)}
                    </td>
                    <td style={styles.td}>{limit.maxAmount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={styles.noData}>Aucune limite définie</div>
        )}
      </div>

      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>Ajouter une Nouvelle Limite</h3>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Date</label>
            <input
              type="date"
              name="date"
              value={form.date}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Heure - De</label>
            <input
              type="time"
              name="fromHour"
              value={form.fromHour}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Heure - À</label>
            <input
              type="time"
              name="toHour"
              value={form.toHour}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Montant Maximum à Gagner</label>
            <input
              type="number"
              name="amount"
              value={form.amount}
              onChange={handleChange}
              style={styles.input}
              placeholder="Ex: 5000"
              required
              min="0"
            />
          </div>

          <button type="submit" style={styles.button} disabled={isLoading}>
            {isLoading ? "Envoi en cours..." : "Envoyer"}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "100%",
    width: "90%",
    margin: "20px auto",
    padding: 20,
    backgroundColor: "#1a1a1a",
    borderRadius: 10,
    color: "#fff",
    fontFamily: "Arial, sans-serif",
    boxShadow: "0 0 10px rgba(255, 0, 0, 0.5)",
  },
  title: {
    textAlign: "center",
    marginBottom: 30,
    color: "#ff5555",
    fontSize: "1.8rem",
  },
  section: {
    marginBottom: 30,
    padding: 15,
    backgroundColor: "#2a2a2a",
    borderRadius: 8,
  },
  sectionTitle: {
    marginTop: 0,
    color: "#ff5555",
    borderBottom: "1px solid #444",
    paddingBottom: 10,
    fontSize: "1.2rem",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  label: {
    marginBottom: 5,
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: 10,
    borderRadius: 5,
    border: "1px solid #444",
    backgroundColor: "#333",
    color: "#fff",
    fontSize: "1rem",
    boxSizing: "border-box",
  },
  button: {
    padding: 12,
    backgroundColor: "#ff5555",
    color: "#fff",
    border: "none",
    borderRadius: 5,
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: 10,
    fontSize: "1rem",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "500px",
  },
  th: {
    backgroundColor: "#333",
    padding: 12,
    textAlign: "left",
    borderBottom: "2px solid #ff5555",
    whiteSpace: "nowrap",
  },
  td: {
    padding: 10,
    borderBottom: "1px solid #444",
    whiteSpace: "nowrap",
  },
  trEven: {
    backgroundColor: "#2a2a2a",
  },
  trOdd: {
    backgroundColor: "#222",
  },
  loading: {
    textAlign: "center",
    padding: 20,
    color: "#aaa",
  },
  noData: {
    textAlign: "center",
    padding: 20,
    color: "#888",
  },
  error: {
    color: "#ff5555",
    backgroundColor: "#2a1a1a",
    padding: 10,
    borderRadius: 5,
    marginBottom: 20,
    textAlign: "center",
  },
};

export default WinLimitManager;
